var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6355 4.48507C14.987 3.77921 15.7097 3.33337 16.4974 3.33337H24.336C25.1237 3.33337 25.8464 3.77921 26.198 4.48507L26.6667 5.41671H32.9167C34.0691 5.41671 35 6.34965 35 7.50004C35 8.65043 34.0691 9.58337 32.9167 9.58337H7.91671C6.76632 9.58337 5.83337 8.65043 5.83337 7.50004C5.83337 6.34965 6.76632 5.41671 7.91671 5.41671H14.1667L14.6355 4.48507V4.48507ZM31.5365 33.6784C31.4323 35.3842 30.0717 36.6667 28.418 36.6667H12.4154C10.765 36.6667 9.39913 35.3842 9.29626 33.6784L7.85811 11.6667H32.9167L31.5365 33.6784Z",
    fill: "#2D5063"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectDark);
export default __webpack_public_path__ + "static/media/reject-dark.33998190ec1d0d8c5eca277b55d2cec9.svg";
export { ForwardRef as ReactComponent };